import isServer from '../isServer';

const isMaxMedia = (size: number) => !isServer() && window.outerWidth <= size;

export default isMaxMedia;
